const path = 'https://ay-backend.herokuapp.com';
// const path = 'http://localhost:8001';

export const logIn = `${path}/api/login`

export const profileLogIn = `${path}/api/profile-login`

export const profiles = `${path}/api/profiles`

export const createProfile = `${path}/api/create-profile`

export const getProfileData = `${path}/api/get-profile`

export const getAccountData = `${path}/api/get-account`

export const authenticateProfile = `${path}/api/profile-authentication`

export const isProtected = `${path}/api/is-protected`

export const updateAccount = `${path}/api/update-account`

export const changeProfilePinCode = `${path}/api/update-pin`

export const getLatestData = `${path}/api/latest-data`

export const getRandomPreview = `${path}/api/preview-random`

export const getStreamLare = `${path}/api/get`